import { composeReducers } from 'complionUtil';
import {
    LOAD_STUDY_SIGNATURE_EXPECTATIONS_V2,
    LOAD_STUDY_SIGNATURES_V2,
    SATISFY_SIGNATURE_EXPECTATIONS_V2,
} from 'pages/delegationOfAuthority/v2/actions/studySignaturesV2';

export function loadSignatureExpectations(state, action) {
    if (action && action.type !== LOAD_STUDY_SIGNATURE_EXPECTATIONS_V2) {
        return state;
    }

    const signatureExpectations = action.payload;
    return {
        ...state,
        doaSignatureExpectations: signatureExpectations,
    };
}

export function loadStudySignatures(state, action) {
    if (action && action.type === 'LOADING_STUDY_SIGNATURES_V2') {
        return {
            ...state,
            app: {
                ...state.app,
                loadingStudySignatures: true,
            }
        };
    }

    if (!action || action.type !== LOAD_STUDY_SIGNATURES_V2) {
        return state;
    }

    const signatures = action.payload;
    const delegations = state.doaStudyDelegations;
    return updateSignatures(state, signatures, delegations);
}

export function satisfySignatureExpectations(state, action) {
    if (!action || action.type !== SATISFY_SIGNATURE_EXPECTATIONS_V2) {
        return state;
    }

    const signatures = action.payload;
    const delegations = state.doaStudyDelegations;
    return updateSignatures(state, signatures, delegations);
}

function updateSignatures(state, signatures, delegations) {
    const updatedDelegations = delegations.map(delegation => {
        if (!delegation.signatures) {
            delegation.signatures = [];
        }

        return delegation;
    });

    signatures.forEach(sig => {
        const delegation = updatedDelegations.find(d => d.id === sig.delegationId);
        if (!delegation) {
            return;
        }

        const delegationSignature = delegation.signatures.find(signature => signature.id === sig.id);
        if (delegation && !delegationSignature) {
            delegation.signatures.push(sig);
        }
    });

    return {
        ...state,
        doaStudyDelegations: delegations,
        doaStudySignatures: signatures,
        app: {
            ...state.app,
            loadingStudySignatures: false,
        }
    };
}

export default composeReducers(
    loadSignatureExpectations,
    loadStudySignatures,
    satisfySignatureExpectations,
);